import { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UsersService } from "../../../../globals/services/users.service";
import styles from "./ReminderBox.module.scss";
import { EventsService } from "../../../../globals/services/events.service";
import ConfirmationModal from "../../../../globals/core/ConfirmationModal/ConfirmationModal";
import sendIcon from "../../../../assets/images/send-message-envelope.svg";
import { ITask } from "../../../../models/tasks";
import { Spinner } from "reactstrap";

interface IReminderBox {
  task: ITask;
  eventId: string;
  eventTitle: string;
}

interface IParticipant {
  contactSFId: string;
  firstName: string;
  lastName: string;
  _id: string;
}

const ReminderBox = ({ task, eventId, eventTitle }: IReminderBox) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [confirmationModal, setConfirmationModal] = useState<any>({ open: false, title: "", message: "", buttons: [] });
  const [participants, setParticipants] = useState<Array<IParticipant>>([]);

  const usersService = UsersService();
  const eventsService = EventsService();

  useEffect(() => {
    if (task && eventId) getData();
  }, [task, eventId]);

  const getData = async () => {
    try {
      const participants = await eventsService.getTaskNonCompleteParticipantsById(task.Id, eventId);
      setParticipants(participants);
    } catch (err) {
      console.log(err);
    }
  };

  const onRemoveParticipant = (participant: any) => {
    setConfirmationModal({
      open: true,
      title: `Are you sure you want to remove ${participant?.firstName} ${participant?.lastName}?`,
      buttons: [
        { label: "Cancel", style: "info", onClick: () => setConfirmationModal({ open: false }) },
        { label: "Yes, Remove", style: "error", onClick: () => removeParticipant(participant) },
      ],
    });
  };

  const removeParticipant = (participant: IParticipant) => {
    setParticipants((prev) => prev.filter((p) => p._id !== participant._id));
    setConfirmationModal({ open: false });
  };

  const sendReminderForNonTaskCompleters = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const ids = participants.map((participant) => participant._id); //todo: send reminder to non task completers
      const mailerRes = await usersService.sendReminderForNonTaskCompleters(ids, task.Id, task.Title__c, eventTitle);
      if (mailerRes.length > 0) console.log("success");
    } catch (e) {}
    setLoading(false);
  };

  return (
    <>
      <Accordion
        sx={{
          boxShadow: "none",
          "&::before": { display: "none" },
          ".MuiAccordionSummary-root.Mui-expanded": { minHeight: "48px" },
          "&.MuiAccordion-root.Mui-expanded": { margin: 0 },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "white",
            border: "1px solid #dde2e5",
            borderRadius: 1,
            padding: "0 5px 0 10px",
            "&.Mui-expanded": { border: "1px solid #0089ce", color: "#0089ce" },
            ".MuiAccordionSummary-content": { display: "flex", justifyContent: "space-between", margin: "4px 0", alignItems: "center" },
            ".MuiAccordionSummary-content.Mui-expanded": { margin: "4px 0" },
          }}
        >
          <div className={styles.accordionSummaryLabel}>{`${task.Title__c} ${participants.length ? `(${participants.length})` : ""}`}</div>
          <div className={styles.sendReminderBtn} onClick={sendReminderForNonTaskCompleters}>
            {loading ? (
              <Spinner size={"sm"} />
            ) : (
              <>
                <img src={sendIcon} className={styles.sendIcon} alt="send" />
                Send Reminder
              </>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#f5f6f8", maxHeight: "18vh", overflow: "scroll", padding: "8px 10px 6px" }}>
          {participants.length ? (
            participants.map((participant, index) => (
              <div key={index} className={styles.participantRow}>
                <div className={styles.participantNAme}>{`${participant.firstName} ${participant?.lastName}`}</div>
                <div className={styles.close} onClick={() => onRemoveParticipant(participant)}>
                  x
                </div>
              </div>
            ))
          ) : (
            <div className={styles.noParticipants}>All participants has complete this task</div>
          )}
        </AccordionDetails>
      </Accordion>
      <ConfirmationModal {...confirmationModal} onClose={() => setConfirmationModal({ open: false })} />
    </>
  );
};

export default ReminderBox;
